var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 57,
    viewBox: "0 0 79 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 57,
    rx: 20,
    fill: "#66A5EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6795 25.2254C28.5431 33.6403 35.4179 40.3306 43.9651 43.9575L45.3352 44.568C48.4698 45.9646 52.1547 44.9036 54.0666 42.0538L55.8571 39.3851C56.4392 38.5175 56.262 37.3488 55.4488 36.6928L49.3767 31.7942C48.4848 31.0747 47.1733 31.2422 46.491 32.1629L44.6126 34.6976C39.7926 32.32 35.8793 28.4067 33.5016 23.5866L36.0363 21.7082C36.957 21.0259 37.1246 19.7145 36.4051 18.8226L31.5063 12.7503C30.8504 11.9373 29.682 11.7599 28.8144 12.3417L26.1273 14.1434C23.2597 16.0662 22.2046 19.7815 23.6334 22.9245L24.6779 25.222L24.6795 25.2254Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeCall);
export default __webpack_public_path__ + "static/media/take_call.d418ec3528bc28f4cbe9804c9bad66b0.svg";
export { ForwardRef as ReactComponent };